var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrap"},[_c(_vm.isLink ? 'router-link' : 'div',{tag:"router-link",attrs:{"to":"/"}},[_c('div',{staticClass:"logo",domProps:{"innerHTML":_vm._s(require('../../assets/bee.svg'))}}),(_vm.showText)?_c('div',{staticClass:"logo-text"},[_c('span',[_vm._v("The")]),_c('span',[_vm._v("Bees Knees")])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }